module.exports = __webpack_public_path__ + "static/index/img/baikal-704.422f20c7.jpg";